import React, { useState } from "react";
import styles from "./Accordion.module.scss";

const Accordion = ({ index, question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.accordion}>
      <button className={styles.question} onClick={() => setIsOpen(!isOpen)}>
        <span className={styles.serialNumber}>{index + 1}.</span> {question}
      </button>
      {isOpen && <p className={styles.answer}>{answer}</p>}
    </div>
  );
};

export default Accordion;
